export const validLimits = [
  1500, 750, 500, 375, 300, 250, 214, 187, 150, 125, 100, 75, 60, 50, 40, 30,
  20, 15, 10, 8, 6, 5, 4, 3, 2, 1,
];
